import { InsightIntent } from '@wix/domains-serverless-interface';
import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
import { createApiClient, createQueriesConfig, QueryConfigTypes } from '@wix/premium-fed-sdk/@apis-infra-react';
const FALLBACK_TITLE_KEYS = ['domains_search_gate.results_optimisations.llm_title.random1', 'domains_search_gate.results_optimisations.llm_title.random2', 'domains_search_gate.results_optimisations.llm_title.random3'];
const pickFallbackTitleKey = domain => {
  const seed = Array.from(domain).reduce((acc, character) => acc + character.charCodeAt(0), 0);
  return FALLBACK_TITLE_KEYS[seed % FALLBACK_TITLE_KEYS.length];
};
const apiConfig = createQueriesConfig({
  exactMatchHeadline: {
    queryFn: async _ref => {
      let {
        httpClient,
        request: {
          domain
        }
      } = _ref;
      const {
        getInsight
      } = DomainsApiClient.queries({
        httpClient
      });
      const description = await getInsight({
        domain,
        intent: {
          intent: InsightIntent.EXACT_MATCH
        }
      }, {
        useErrorBoundary: false
      }).then(response => {
        var _response$insight;
        return response == null || (_response$insight = response.insight) == null ? void 0 : _response$insight.description;
      }).catch(() => undefined);
      return {
        description,
        fallbackTitleKey: pickFallbackTitleKey(domain)
      };
    },
    queryConfigType: QueryConfigTypes.FIXED_DATA
  }
});
export const exactMatchHeadlineApiClient = createApiClient(apiConfig);
//# sourceMappingURL=ExactMatchHeadline.apiClient.js.map